module.exports = require("@mui/material/StepConnector");